import newSystemTh from './newsystem-th'

const th = {

    campus : "ชื่อสถาบันอุดมศึกษา",
    faculty: "สำนักวิชา",
    department: "สาขาวิชา",
    academicYear:"ปีการศึกษา",
    semester:"ภาคการศึกษา",
    course:"เลือกรายวิชา",


    button: {
        setting:"ตั้งค่า",
        create :"สร้าง",
    },
    description : "รายละเอียด",
    preferences: {
        title: "การตั้งค่า",
        subtitle: "จัดการพฤติกรรมการใช้งาน การแจ้งเตือน รูปแบบหน้าจอ และตัวเลือกความเป็นส่วนตัวสำหรับเบราว์เซอร์นี้",
        workspaceSettings: "การตั้งค่าพื้นที่ทำงาน",
        personalPreferences: "การตั้งค่าส่วนบุคคล",
        personalPreferencesCopy: "การตั้งค่าเหล่านี้จะถูกบันทึกไว้ในเบราว์เซอร์ของคุณ เพื่อให้คุณปรับแต่งการใช้งานได้โดยไม่กระทบผู้ใช้คนอื่น",
        currentState: "สถานะปัจจุบัน",
        recommendations: "คำแนะนำ",
        whatSavesHere: "สิ่งที่บันทึกที่นี่",
        storageNote: "การตั้งค่าเหล่านี้ถูกเก็บไว้ใน local storage ของเบราว์เซอร์เท่านั้น และจะไม่เปลี่ยนบัญชีอื่นหรือค่ากลางของระบบ",
        save: "บันทึกการตั้งค่า",
        reset: "รีเซ็ตเป็นค่าเริ่มต้น",
        enabled: "เปิดใช้งาน",
        disabled: "ปิดใช้งาน",
        standard: "มาตรฐาน",
        reduced: "ลดการจดจำ",
        expanded: "ขยาย",
        compact: "กะทัดรัด",
        languageEnglish: "อังกฤษ",
        languageThai: "ไทย",
        time24: "24 ชั่วโมง",
        time12: "12 ชั่วโมง",
        sections: {
            languageRegion: "ภาษาและภูมิภาค",
            languageRegionCopy: "เลือกวิธีที่ระบบจะแสดงข้อความและเวลา",
            notifications: "การแจ้งเตือน",
            notificationsCopy: "ควบคุมระดับการแจ้งเตือนที่คุณจะได้รับระหว่างการทำงานในระบบ",
            layoutNavigation: "หน้าจอและการนำทาง",
            layoutNavigationCopy: "กำหนดค่าเริ่มต้นที่ต้องการสำหรับการใช้งานและการนำทาง",
            privacySession: "ความเป็นส่วนตัวและเซสชัน",
            privacySessionCopy: "เลือกว่ากิจกรรมในเครื่องนี้ควรถูกจดจำมากน้อยเพียงใด"
        },
        fields: {
            language: "ภาษา",
            timeFormat: "รูปแบบเวลา",
            defaultLandingPage: "หน้าเริ่มต้น",
            resultsPerPage: "จำนวนรายการต่อหน้า",
            emailAlerts: "การแจ้งเตือนอีเมล",
            desktopAlerts: "การแจ้งเตือนเดสก์ท็อป",
            reviewAlerts: "การแจ้งเตือนการรีวิว",
            sidebarMemory: "การจำสถานะเมนูด้านข้าง",
            landingPage: "หน้าเริ่มต้น"
        },
        toggles: {
            emailNotificationsTitle: "การแจ้งเตือนทางอีเมล",
            emailNotificationsCopy: "รับสรุปและอัปเดตเวิร์กโฟลว์ผ่านอีเมล",
            desktopNotificationsTitle: "การแจ้งเตือนบนเดสก์ท็อป",
            desktopNotificationsCopy: "แสดงการแจ้งเตือนของเบราว์เซอร์เมื่อมีงานรีวิวใหม่หรือมีการเปลี่ยนสถานะ",
            reviewAlertsTitle: "การแจ้งเตือนการรีวิว",
            reviewAlertsCopy: "เน้นความคิดเห็นใหม่ของคณะกรรมการและกิจกรรมการมอบหมายงาน",
            translationAlertsTitle: "การแจ้งเตือนงานแปล",
            translationAlertsCopy: "แจ้งเตือนเมื่อคำขอแปลมีการเปลี่ยนสถานะ",
            rememberSidebarTitle: "จำสถานะเมนูด้านข้าง",
            rememberSidebarCopy: "คงสถานะเมนูด้านข้างแบบขยายหรือย่อไว้ตามที่คุณใช้งานครั้งล่าสุด",
            startMinimizedSidebarTitle: "เริ่มต้นด้วยเมนูด้านข้างแบบย่อ",
            startMinimizedSidebarCopy: "ใช้รูปแบบการนำทางแบบกะทัดรัดเป็นค่าเริ่มต้น",
            keepNavigationContextTitle: "เปิดลิงก์ในพื้นที่ทำงานปัจจุบัน",
            keepNavigationContextCopy: "ให้ใช้งานต่อในแอปเดิมแทนการเปิดแท็บใหม่",
            rememberRecentPagesTitle: "จำหน้าที่เพิ่งเปิดล่าสุด",
            rememberRecentPagesCopy: "เก็บประวัติการเข้าถึงแบบย่อเพื่อกลับไปยังหน้าที่ใช้งานได้เร็วขึ้น",
            storeDraftRecoveryTitle: "เก็บข้อมูลช่วยกู้ฉบับร่าง",
            storeDraftRecoveryCopy: "เก็บข้อมูลช่วยกู้คืนงานที่ยังทำไม่เสร็จไว้ในเบราว์เซอร์นี้",
            confirmBeforeSignOutTitle: "แสดงการยืนยันก่อนออกจากระบบ",
            confirmBeforeSignOutCopy: "เพิ่มขั้นตอนยืนยันก่อนออกจากพื้นที่ทำงาน"
        },
        stats: {
            alertsOn: "ช่องทางแจ้งเตือน",
            alertsOnHint: "จำนวนช่องทางการแจ้งเตือนที่เปิดอยู่",
            layout: "รูปแบบหน้าจอ",
            layoutHint: "โหมดเมนูด้านข้างเริ่มต้น",
            privacy: "ความเป็นส่วนตัว",
            privacyHint: "ลักษณะการจดจำข้อมูลในเครื่อง"
        },
        tips: {
            focusedReviewerTitle: "ผู้รีวิวที่ต้องการโฟกัส",
            focusedReviewerCopy: "เปิดการแจ้งเตือนการรีวิวและการจำสถานะเมนูด้านข้างเพื่อให้ติดตามคิวงานได้ง่าย",
            frequentDrafterTitle: "ผู้สร้างร่างบ่อย",
            frequentDrafterCopy: "เปิดการเก็บข้อมูลช่วยกู้ฉบับร่างและตั้งค่าหน้าเริ่มต้นให้เปิดที่หน้าข้อตกลงโดยตรง",
            sharedDeviceTitle: "อุปกรณ์ที่ใช้ร่วมกัน",
            sharedDeviceCopy: "ปิดการจำหน้าล่าสุดหากเบราว์เซอร์นี้มีผู้ใช้งานมากกว่าหนึ่งคน"
        },
        landingOptions: {
            dashboard: "แดชบอร์ด",
            myAgreements: "ข้อตกลงของฉัน",
            myReviewQueue: "คิวรีวิวของฉัน",
            myTranslationRequests: "คำขอแปลของฉัน",
            myReports: "รายงานของฉัน",
            committeeDashboard: "แดชบอร์ดคณะกรรมการ",
            review: "รีวิว",
            reviewHistory: "ประวัติการรีวิว",
            guideline: "คู่มือ"
        }
    },
    shell: {
        dashboard: "แดชบอร์ด",
        signOut: "ออกจากระบบ",
        profile: "โปรไฟล์",
        preferences: "การตั้งค่า",
        general: "ทั่วไป",
        permission: "สิทธิ์การใช้งาน",
        admin: "ผู้ดูแลระบบ",
        committee: "คณะกรรมการ",
        user: "ผู้ใช้",
        multiUser: "พื้นที่ทำงาน",
        navigation: {
            allAgreements: "ข้อตกลงทั้งหมด",
            auditLog: "บันทึกการตรวจสอบ",
            clauseLibrary: "คลังข้อกำหนด",
            reviewQueue: "คิวรีวิว",
            translationRequests: "คำขอแปล",
            reportsAnalytics: "รายงานและการวิเคราะห์",
            accountDirectory: "รายชื่อบัญชี",
            rolePermissionMatrix: "ตารางสิทธิ์ตามบทบาท",
            reviewAssignments: "การมอบหมายงานรีวิว",
            createMenu: "สร้างเมนู",
            createGroup: "สร้างกลุ่ม",
            review: "รีวิว",
            reviewHistory: "ประวัติการรีวิว",
            userManual: "คู่มือผู้ใช้",
            helpSupport: "ช่วยเหลือและสนับสนุน",
            myAgreements: "ข้อตกลงของฉัน",
            myClauseLibrary: "คลังข้อกำหนดของฉัน",
            myReviewQueue: "คิวรีวิวของฉัน",
            myTranslationRequests: "คำขอแปลของฉัน",
            myReports: "รายงานของฉัน"
        }
    },
    common: {
        lastUpdated: "อัปเดตล่าสุด",
        refresh: "รีเฟรช"
    },
    routes: {
        dashboard: { title: "แดชบอร์ด", description: "ภาพรวมของพื้นที่ทำงานปัจจุบันและแดชบอร์ดตามบทบาทที่ใช้งานได้" },
        adminDashboard: { title: "แดชบอร์ดผู้ดูแลระบบ", description: "มุมมองระดับระบบสำหรับข้อตกลง สิทธิ์ การวิเคราะห์ และประวัติการตรวจสอบ" },
        committeeDashboard: { title: "แดชบอร์ดคณะกรรมการ", description: "ตรวจสอบงานที่มอบหมาย การตัดสินใจ ประวัติ และคู่มือสำหรับคณะกรรมการ" },
        review: { title: "รีวิว", description: "เปิดเคสที่ได้รับมอบหมายและดำเนินการรีวิวของคณะกรรมการ" },
        reviewHistory: { title: "ประวัติการรีวิว", description: "ดูการรีวิวที่เสร็จสิ้นแล้วและการตัดสินใจก่อนหน้าของคณะกรรมการ" },
        guideline: { title: "คู่มือ", description: "เผยแพร่และทบทวนแนวทาง กฎ และเอกสารอ้างอิงในการปฏิบัติงาน" },
        help: { title: "ช่วยเหลือและสนับสนุน", description: "ให้คำถามที่พบบ่อย ช่องทางติดต่อ และทรัพยากรช่วยเหลือสำหรับผู้ใช้" },
        userAgreements: { title: "ข้อตกลงของฉัน", description: "สร้าง ส่ง และติดตามเวิร์กโฟลว์ข้อตกลงของคุณ" },
        userClauseLibrary: { title: "คลังข้อกำหนดของฉัน", description: "ใช้ข้อกำหนดเริ่มต้นซ้ำและจัดการคลังข้อกำหนดของคุณเอง" },
        userReviewQueue: { title: "คิวรีวิวของฉัน", description: "ติดตามความคืบหน้าของข้อตกลงผ่านการรีวิวของผู้ดูแลระบบและคณะกรรมการ" },
        userTranslation: { title: "คำขอแปลของฉัน", description: "ขอความช่วยเหลือด้านการแปลสำหรับร่างข้อตกลงและติดตามความคืบหน้า" },
        userReports: { title: "รายงานของฉัน", description: "ดูภาพรวมกิจกรรมข้อตกลงและงานแปลของคุณในที่เดียว" },
        userGuideline: { title: "คู่มือผู้ใช้", description: "อ่านเวิร์กโฟลว์ผู้ใช้และแนวทางเกี่ยวกับข้อตกลงล่าสุด" },
        userNewAgreement: { title: "สร้างข้อตกลง", description: "เริ่มต้นสร้างร่างข้อตกลงใหม่" },
        profile: { title: "โปรไฟล์", description: "อัปเดตรายละเอียดส่วนตัวและตรวจสอบการตั้งค่าโปรไฟล์ในพื้นที่ทำงานของคุณ" },
        preferences: { title: "การตั้งค่า", description: "จัดการการแจ้งเตือน ภาษา และพฤติกรรมเริ่มต้นของพื้นที่ทำงาน" },
        notifications: { title: "การแจ้งเตือน", description: "ตรวจสอบการแจ้งเตือน สิ่งเตือนใจ และรายการอัปเดตที่ยังไม่ได้อ่านในที่เดียว" }
    },
    pages: {
        user: {
            agreements: {
                title: "ข้อตกลงของฉัน",
                subtitle: "สร้าง แก้ไข ส่ง และติดตามข้อตกลงตลอดเวิร์กโฟลว์การรีวิว"
            },
            clauseLibrary: {
                title: "คลังข้อกำหนดของฉัน",
                subtitle: "เรียกดูข้อกำหนดเริ่มต้นและข้อกำหนดที่คุณบันทึกไว้สำหรับการร่างข้อตกลง"
            },
            reviewQueue: {
                title: "คิวรีวิวของฉัน",
                subtitle: "ติดตามว่าข้อตกลงของคุณกำลังรอผู้ดูแลระบบ ข้อเสนอแนะจากคณะกรรมการ หรือการตัดสินใจขั้นสุดท้าย"
            },
            translation: {
                title: "คำขอแปลของฉัน",
                subtitle: "ขอความช่วยเหลือด้านการแปลสำหรับร่างข้อตกลง ตรวจสอบสถานะคำขอ และจัดการงานด้านภาษาไว้ในที่เดียว"
            },
            newAgreement: {
                title: "สร้างข้อตกลงใหม่",
                subtitle: "เลือกประเภทข้อตกลงก่อน จากนั้นค่อยตัดสินใจว่าจะใช้เทมเพลต เขียนร่างเอง หรือนำเข้าสัญญา"
            },
            reports: {
                title: "รายงานของฉัน",
                subtitle: "ติดตามจำนวนข้อตกลง พื้นที่ทางภูมิศาสตร์ หน่วยงานที่รับผิดชอบ และการเคลื่อนไหวของเวิร์กโฟลว์จากข้อมูลข้อตกลงของคุณ",
                range: "ช่วงเวลา"
            },
            guideline: {
                title: "คู่มือผู้ใช้",
                subtitle: "ทำให้เวิร์กโฟลว์ข้อตกลง ขั้นตอนการขอแปล และกฎการส่งงานเข้าใจได้ง่าย",
                currentVersion: "เวอร์ชันปัจจุบัน",
                sections: {
                    workflow: "ขั้นตอนการทำงาน",
                    resources: "แหล่งข้อมูลที่เป็นประโยชน์",
                    faq: "คำถามที่พบบ่อย"
                }
            }
        },
        dashboard: {
            user: {
                heroKicker: "แดชบอร์ดผู้ใช้",
                heroTitle: "ทำให้เวิร์กโฟลว์ข้อตกลงของคุณเดินหน้าต่อได้",
                heroCopy: "ติดตามร่างของคุณตั้งแต่การส่งงาน การรีวิวโดยคณะกรรมการ การแก้ไขหลายรอบ ไปจนถึงการตัดสินใจขั้นสุดท้ายของผู้ดูแลระบบในที่เดียว",
                myAgreements: "ข้อตกลงของฉัน",
                myReviewQueue: "คิวรีวิวของฉัน",
                translationRequests: "คำขอแปล",
                inReview: "กำลังรีวิว",
                inReviewCopy: "ข้อตกลงที่กำลังรอการมอบหมายจากผู้ดูแลระบบ การรีวิวของคณะกรรมการ หรือการตัดสินใจขั้นสุดท้าย",
                monthlyActivityTitle: "กิจกรรมรายเดือน",
                monthlyActivitySubtitle: "การเคลื่อนไหวของข้อตกลงและงานแปลในช่วงหลายเดือนที่ผ่านมา",
                agreementStatusTitle: "สถานะข้อตกลง",
                agreementStatusSubtitle: "ภาพรวมของข้อตกลงของคุณตามสถานะการอนุมัติ",
                quickActionsTitle: "การดำเนินการด่วน",
                quickActionsSubtitle: "ไปยังงานถัดไปของคุณได้ทันที",
                recentAgreementsTitle: "ข้อตกลงล่าสุด",
                recentAgreementsSubtitle: "รายการข้อตกลงล่าสุดของคุณและสถานะปัจจุบัน",
                recentTranslationsTitle: "คำขอแปลล่าสุด",
                recentTranslationsSubtitle: "คำขอสนับสนุนที่เกี่ยวข้องกับงานข้อตกลงของคุณ",
                drafts: "ฉบับร่าง",
                draftsDelta: "ร่างที่คุณยังแก้ไขได้ก่อนส่ง",
                reviewCount: "กำลังรีวิว",
                reviewCountDelta: "รายการที่กำลังเคลื่อนผ่านการมอบหมาย การรีวิวของคณะกรรมการ และการอนุมัติขั้นสุดท้าย",
                approved: "อนุมัติแล้ว",
                approvedDelta: "ข้อตกลงที่เสร็จสมบูรณ์และผ่านการอนุมัติแล้ว",
                rejected: "ปฏิเสธแล้ว",
                active: "อยู่ระหว่างดำเนินการ",
                agreementsDataset: "ข้อตกลง",
                translationsDataset: "งานแปล",
                createAgreement: "สร้างข้อตกลง",
                createAgreementCopy: "เริ่มต้นร่างข้อตกลงใหม่",
                openReviewQueue: "เปิดคิวรีวิว",
                openReviewQueueCopy: "ตรวจสอบความเห็นจากคณะกรรมการ คำขอแก้ไข และสถานะสุดท้ายของผู้ดูแลระบบ",
                requestTranslation: "ขอแปล",
                requestTranslationCopy: "ส่งเอกสารเพื่อรับการสนับสนุนด้านการแปล",
                open: "เปิด",
                noAgreementsYet: "ยังไม่มีข้อตกลง",
                noTranslationRequestsYet: "ยังไม่มีคำขอแปล",
                justNow: "เมื่อสักครู่"
            },
            committee: {
                heroKicker: "แดชบอร์ดคณะกรรมการ",
                heroTitle: "ขับเคลื่อนการรีวิวของคณะกรรมการด้วยภาพรวมที่ชัดเจน",
                heroCopy: "ติดตามคิวรีวิวร่วมของคณะกรรมการ เคสเร่งด่วน ความคืบหน้าการปิดงาน และขั้นตอนถัดไป โดยไม่ต้องออกจากพื้นที่ทำงานของคณะกรรมการ",
                openReviewPage: "เปิดหน้ารีวิว",
                reviewHistory: "ประวัติการรีวิว",
                guideline: "คู่มือ",
                deadlineEyebrow: "แจ้งเตือนกำหนดส่งเร่งด่วน",
                openReview: "เปิดรีวิว",
                panelActivityTitle: "ภาพรวมกิจกรรมของคณะกรรมการ",
                panelActivitySubtitle: "ดูการกระจายงานรีวิวปัจจุบันและจุดที่ต้องให้ความสำคัญเป็นลำดับถัดไป",
                chartHeadline: "การกระจายภาระงานของคณะกรรมการในคิวรีวิวปัจจุบัน",
                currentFocus: "โฟกัสปัจจุบัน",
                currentFocusValue: "กำลังดำเนินรีวิวอยู่ {count} รายการ",
                dueSoon: "ใกล้ครบกำหนด",
                dueSoonValue: "มี {count} รายการที่ต้องรีบดำเนินการ",
                completedThisWeek: "เสร็จสิ้นสัปดาห์นี้",
                completedThisWeekValue: "ปิดรีวิวแล้ว +{count} รายการ",
                quickActionsTitle: "การดำเนินการด่วน",
                quickActionsSubtitle: "ไปยังงานถัดไปของคณะกรรมการได้ทันที",
                queueTitle: "คิวรีวิวที่กำลังดำเนินการ",
                queueSubtitle: "ข้อตกลงในขั้นคณะกรรมการที่ยังต้องดำเนินการรีวิว",
                highPriorityDeadline: "กำหนดส่งสำคัญ",
                open: "เปิด",
                noQueueItems: "ขณะนี้ไม่มีรายการคิวคณะกรรมการที่กำลังดำเนินการ",
                workloadBreakdown: "สัดส่วนภาระงาน",
                workloadBreakdownSubtitle: "ภาพรวมการกระจายภาระงานของคณะกรรมการในตอนนี้",
                deadlinePressure: "แรงกดดันจากกำหนดเวลา",
                deadlinePressureSubtitle: "งานรีวิวที่ต้องจับตาอย่างใกล้ชิดในตอนนี้",
                currentFocusCard: "งานที่กำลังโฟกัส",
                currentFocusCardSubtitle: "สิ่งที่คณะกรรมการกำลังขับเคลื่อนอยู่ในวันนี้",
                pending: "รอดำเนินการ",
                inProgress: "กำลังดำเนินการ",
                sentToAdmin: "ส่งให้ผู้ดูแลแล้ว",
                completed: "เสร็จสิ้น",
                topUrgentItem: "งานเร่งด่วนสูงสุด",
                noUrgentItems: "ไม่มีงานเร่งด่วน",
                daysLeft: "วันที่เหลือ",
                stable: "ปกติ",
                startedToday: "เริ่มวันนี้",
                averageReviewTime: "เวลารีวิวเฉลี่ย",
                activeAgreement: "ข้อตกลงที่กำลังดำเนินการ",
                noActiveReview: "ไม่มีรีวิวที่กำลังดำเนินการ",
                openReviewPageCopy: "เริ่มหรือดำเนินงานรีวิวของคณะกรรมการต่อ",
                reviewHistoryCopy: "ย้อนดูผลการตัดสินใจของคณะกรรมการที่เสร็จสิ้นแล้ว",
                guidelineCopy: "เปิดคู่มือและบันทึกอ้างอิงของคณะกรรมการ",
                pendingReview: "รอการรีวิว",
                pendingReviewDelta: "ใกล้ครบกำหนด {count} รายการ",
                inProgressDelta: "เริ่มวันนี้ {count} รายการ",
                sentToAdminDelta: "รอการตัดสินใจขั้นสุดท้ายจากผู้ดูแล",
                completedDelta: "สัปดาห์นี้ +{count} รายการ",
                averageReviewTimeDelta: "รอบปัจจุบัน",
                statusPending: "รอการรีวิว",
                statusInProgress: "กำลังดำเนินการ",
                statusCompleted: "เสร็จสิ้น",
                dueToday: "ครบกำหนดวันนี้",
                oneDayLeft: "เหลือ 1 วัน",
                daysLeftValue: "เหลือ {count} วัน",
                inReviewChart: "กำลังพิจารณา",
                sentToAdminChart: "ส่งให้ผู้ดูแลแล้ว",
                completedChart: "เสร็จสิ้น",
                committeeReviewsDataset: "งานรีวิวของคณะกรรมการ",
                justNow: "เมื่อสักครู่",
                highPriorityTitle: "{agreement} กลายเป็นงานสำคัญเร่งด่วน",
                highPriorityText: "กำหนดเวลาการรีวิวของคณะกรรมการคือ 7 วันนับจากวันที่มอบหมาย รายการนี้เหลือเวลา {timeRemaining} จึงต้องดำเนินการทันที",
                dueTodayBadge: "ครบกำหนดวันนี้",
                daysLeftBadge: "เหลือ {count} วัน"
            },
            admin: {
                heroKicker: "แดชบอร์ดผู้ดูแลระบบ",
                heroTitle: "ยินดีต้อนรับกลับ ผู้ดูแลระบบ",
                heroCopy: "ติดตามข้อตกลง ความคืบหน้าการรีวิว อุปกรณ์ที่เชื่อถือได้ และงานสำคัญของผู้ดูแลระบบที่เกี่ยวข้องกับแต่ละ MOU",
                viewAgreements: "ดูข้อตกลง",
                reviewQueue: "คิวรีวิว",
                openReports: "เปิดรายงาน",
                justNow: "เมื่อสักครู่"
            }
        }
    }
}

function mergeLocale(target, source) {
    Object.keys(source || {}).forEach((key) => {
        const sourceValue = source[key]
        const targetValue = target[key]
        if (
            sourceValue &&
            typeof sourceValue === 'object' &&
            !Array.isArray(sourceValue) &&
            targetValue &&
            typeof targetValue === 'object' &&
            !Array.isArray(targetValue)
        ) {
            mergeLocale(targetValue, sourceValue)
            return
        }
        target[key] = sourceValue
    })
    return target
}

mergeLocale(th, newSystemTh)

export default th
